import React from 'react'
import { Offcanvas } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const DashboardSideBar = (props) => {
    const {t, i18n} = useTranslation();
    let lang = localStorage.getItem("lang")
    let userdata = JSON.parse(localStorage.getItem("user"))

    if(userdata && userdata.role === "DEVELOPER") {
      return (
        <div className={props.style}>
            <Offcanvas.Header >
              <Offcanvas.Title>{t("dashboard_title")}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='dashboard_nav'>
              <div>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard" className="nav_link">
                  <span> {t("dashboard_nav_dashboard")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard/saloons" className="nav_link">
                  <span> {t("dashboard_nav_saloons")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard/messages" className="nav_link">
                  <span> {t("dashboard_nav_messages_management")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard/site-management" className="nav_link">
                  <span> {t("dashboard_nav_site_management")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/account" className="nav_link">
                  <span> {t("dashboard_nav_user_account")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/developer-companies-management" className="nav_link">
                  <span> {t("dashboard_nav_companies_management")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/users-management" className="nav_link">
                  <span> {t("dashboard_nav_users_management")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/companies-reviews-management" className="nav_link">
                  <span> {t("dashboard_nav_company_messages")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/admin-tickets" className="nav_link">
                  <span> {t("dashboard_nav_tickets")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/manager-messages" className="nav_link">
                  <span> {t("dashboard_nav_manager_messages")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/expo" className="nav_link">
                  <span> {t("dashboard_nav_virtual_expo")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
              </div>
              <NavLink exact to="/" className="nav_link exit"><span>{t("main_page")}</span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }</NavLink>
            </Offcanvas.Body>
        </div>
      )
    } else if (userdata && userdata.role === "ADMIN") {
      return (
        <div className={props.style}>
            <Offcanvas.Header >
              <Offcanvas.Title>{t("dashboard_title")}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='dashboard_nav'>
              <div>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard" className="nav_link">
                  <span> {t("dashboard_nav_dashboard")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard/saloons" className="nav_link">
                  <span> {t("dashboard_nav_saloons")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard/messages" className="nav_link">
                  <span> {t("dashboard_nav_messages_management")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard/site-management" className="nav_link">
                  <span> {t("dashboard_nav_site_management")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/account" className="nav_link">
                  <span> {t("dashboard_nav_user_account")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/admin-companies-management" className="nav_link">
                  <span> {t("dashboard_nav_companies_management")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/companies-reviews-management" className="nav_link">
                  <span> {t("dashboard_nav_company_messages")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/admin-tickets" className="nav_link">
                  <span> {t("dashboard_nav_tickets")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/manager-messages" className="nav_link">
                  <span> {t("dashboard_nav_manager_messages")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/expo" className="nav_link">
                  <span> {t("dashboard_nav_virtual_expo")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
              </div>
              <NavLink exact to="/" className="nav_link exit"><span>{t("main_page")}</span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }</NavLink>
            </Offcanvas.Body>
        </div>
      )
    } else if (userdata && userdata.role === "ADMIN-CO") {
      return (
        <div className={props.style}>
            <Offcanvas.Header >
              <Offcanvas.Title>{t("dashboard_title")}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='dashboard_nav'>
              <div>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard" className="nav_link">
                  <span> {t("dashboard_nav_dashboard")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" exact to="/dashboard/company-management" className="nav_link">
                  <span> {t("dashboard_nav_company_management")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/categories" className="nav_link">
                  <span> {t("dashboard_nav_categories")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/account" className="nav_link">
                  <span> {t("dashboard_nav_user_account")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/send-ticket" className="nav_link">
                  <span> {t("dashboard_nav_tickets")} </span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
                <NavLink activeClassName="D_active_nav" to="/dashboard/company-manager-messages" className="nav_link">
                  <span> {t("dashboard_nav_manager_messages")} <span className='dash_nav_badge'>{userdata.message_count}</span></span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }
                </NavLink>
              </div>
              <NavLink exact to="/" className="nav_link exit"><span>{t("main_page")}</span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }</NavLink>
            </Offcanvas.Body>
        </div>
      )
    } else {
      return (
        <div className={props.style}>
            <Offcanvas.Header >
              <Offcanvas.Title>{t("dashboard_title")}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='dashboard_nav'>
              <NavLink exact to="/" className="nav_link exit"><span>{t("main_page")}</span>{lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i> }</NavLink>
            </Offcanvas.Body>
        </div>
      )
    }
    
}

export default DashboardSideBar
